import { snakeCase } from 'lodash';
import { ApiService } from 'services';

async function updateIdentity(tokenId, type, identity) {
  const keys = Object.keys(identity).reduce((acc, key) => {
    return {
      ...acc,
      // When the investor is created with a CSV list, the id_number or passport_number might be received as null.
      // Furthermore, the PATCH /holders/me endpoint throws an error with a null value.
      // So, we omit the fields that have a falsy value (except boolean) in the request.
      ...(typeof identity[key] === 'boolean' || !!identity[key]
        ? {
            [snakeCase(key)]: {
              schema: {
                standard: true,
              },
              value: identity[key],
            },
          }
        : {}),
    };
  }, {});

  if (type === 'individual') {
    // this is complete garbage because the API is complete garbage
    keys.politically_exposed = {
      schema: { standard: true },
      value: {
        exposed: false,
        details: '?',
      },
    };
  }

  return ApiService.callApiAuthenticated({
    method: 'PATCH',
    path: `/holders/me`,
    body: { tokenId, notification: true, keys },
  });
}

export default {
  updateIdentity,
};
